import React from 'react';
import Back from "../../../../picture/back.svg";
import './style/backContainer.css';

export default function BackContainer({title, onClick}) {
    return (
        <div className='wz-back-container'>
            <div className='wz-back-icon-container'>
                <div className='wz-back-icon' onClick={onClick}>
                    <img alt='' src={Back}/>
                </div>
            </div>
            <div className='wz-back-title'>
                {title}
            </div>
        </div>
    )
}